__turbopack_context__.v({
  "faqItem": "faq-item-module-scss-module__HA8p6q__faqItem",
  "faqItem_button": "faq-item-module-scss-module__HA8p6q__faqItem_button",
  "faqItem_content": "faq-item-module-scss-module__HA8p6q__faqItem_content",
  "faqItem_icon": "faq-item-module-scss-module__HA8p6q__faqItem_icon",
  "faqItem_title": "faq-item-module-scss-module__HA8p6q__faqItem_title",
});
